import { render } from "./CartHeaderName.vue?vue&type=template&id=e671976e&scoped=true"
import script from "./CartHeaderName.vue?vue&type=script&lang=js"
export * from "./CartHeaderName.vue?vue&type=script&lang=js"

import "./CartHeaderName.vue?vue&type=style&index=0&id=e671976e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e671976e"]])

export default __exports__